import { render, staticRenderFns } from "./Annot8Article.vue?vue&type=template&id=104a79f8&"
import script from "./Annot8Article.vue?vue&type=script&lang=js&"
export * from "./Annot8Article.vue?vue&type=script&lang=js&"
import style0 from "./Annot8Article.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports